import clsx from 'clsx';
import React from 'react';

import { new_forum_post_path } from '../../../routes';
import FlexLink from '../../shared/FlexLink';
import styles from './styles.module.css';

export default function NewForumPostButton() {
  return (
    <div className={styles.writePostBtnWrapper}>
      <FlexLink href={new_forum_post_path()} className={clsx(styles.btn, styles.writePostBtn)}>
        Write a Post
      </FlexLink>
    </div>
  );
}
